var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBold48Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9302 23.5902C32.3902 22.1702 33.3002 20.1902 33.3002 18.0002C33.3002 13.7002 29.8002 10.2002 25.5002 10.2002H17.7002C16.0502 10.2002 14.7002 11.5502 14.7002 13.2002V34.8002C14.7002 36.4502 16.0502 37.8002 17.7002 37.8002H26.5002C30.8002 37.8002 34.3002 34.3002 34.3002 30.0002C34.3002 27.3402 32.9602 25.0002 30.9302 23.5902ZM19.1502 14.6502H25.2902C27.2602 14.6502 28.8502 16.2502 28.8502 18.2102C28.8502 20.1702 27.2502 21.7702 25.2902 21.7702H19.1502V14.6402V14.6502ZM26.2902 33.3502H19.1502V26.2202H26.2902C28.2602 26.2202 29.8502 27.8202 29.8502 29.7802C29.8502 31.7402 28.2502 33.3402 26.2902 33.3402V33.3502Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBold48Line);
export default __webpack_public_path__ + "static/media/icon_bold_48_line.29c27882bcd0b6c721bba4ba6252dcaf.svg";
export { ForwardRef as ReactComponent };